import React from 'react'
import { PanelAddShop } from '../../UI/ShopAds/Add/PanelAddShop'

const ShopAdsAdd = () => {
    return (
        <div>
            <PanelAddShop/>
        </div>
    )
}

export default React.memo(ShopAdsAdd)